export const requestTypes = Object.freeze({
  GET: "GET",
  POST: "POST",
  HEAD: "HEAD",
  PUT: "PUT",
  DELETE: "DELETE",
});